<template>
  <main class="view view--settings">
    <section class="header" id="header">
      <div class="header__left">
        <router-link :to="{ name: 'home' }" class="btn btn-prev"></router-link>
      </div>

      <div class="header__center">
        <p class="title">{{ $t("Badge") }}</p>
      </div>

      <div class="header__right"></div>
    </section>

    <section class="settings" id="qrwrapper">
      <qrcode :value="qrvalue" :options="{ width: qrwidth }"></qrcode>
    </section>
  </main>
</template>

<script>
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
  components: {
    qrcode: VueQrcode,
  },
  mounted: function () {
    var self = this;

    this.$config.getUsername().then((username) => {
      var account = self.$config.get("account");
      this.qrvalue = JSON.stringify({
        account: account.id,
        id: account.user.id,
        name: username,
      });
    });

    window.addEventListener("resize", this._listener);
    this._listener();
  },
  methods: {
    _listener: function () {
      if (
        document.getElementById("app") &&
        document.getElementById("nav") &&
        document.getElementById("header")
      ) {
        var height =
          document.getElementById("app").offsetHeight -
          document.getElementById("nav").offsetHeight -
          document.getElementById("header").offsetHeight;
        var width = document.getElementById("qrwrapper").offsetWidth;
        if (height < width) {
          this.qrwidth = height;
        } else {
          this.qrwidth = width;
        }
      }
    },
  },
  // eslint-disable-next-line no-unused-vars
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("resize", this._listener);
    next();
  },
  data: function () {
    return {
      qrwidth: 200,
      qrvalue: null,
    };
  },
};
</script>
